import { INITIAL_DATA_SELECTOR_DATA } from '@atoms/dataSelectors/dataSelector/dataSelector.data';

import type { TableEditorSelectColumnData } from '@stratumn/studio-shared';

const DEFAULT_HEADER = 'Default Text Column Header';
export const initialSelectData: TableEditorSelectColumnData = {
  title: DEFAULT_HEADER,
  width: 'medium',
  isfixedColumn: false,
  isDisplayedByDefault: true,
  required: true,
  isEditMode: true,
  editorOptions: {
    selectedEditor: 'select',
    editors: {
      select: {
        type: 'select',
        placeholder: 'Select an option',
        options: INITIAL_DATA_SELECTOR_DATA,
        delay: undefined,
        disabledPath: undefined
      }
    }
  }
};
